import { render, staticRenderFns } from "./FactPhoneNumber.vue?vue&type=template&id=c7cc76ca&scoped=true&"
import script from "./FactPhoneNumber.vue?vue&type=script&lang=ts&"
export * from "./FactPhoneNumber.vue?vue&type=script&lang=ts&"
import style0 from "./FactPhoneNumber.vue?vue&type=style&index=0&id=c7cc76ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cc76ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VFlex,VLayout,VTextField})
